import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IKeyword } from 'app/shared/model/keyword.model';
import { getEntities as getKeywords } from 'app/entities/keyword/keyword.reducer';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { ILocation } from 'app/shared/model/location.model';
import { getEntities as getLocations } from 'app/entities/location/location.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { IActivity } from 'app/shared/model/activity.model';
import { ActivityType } from 'app/shared/model/enumerations/activity-type.model';
import { getEntity, updateEntity, createEntity, reset } from './activity.reducer';
import { IDiningDetails } from 'app/shared/model/dining-details.model';
import { getEntities as getDiningDetails } from 'app/entities/dining-details/dining-details.reducer';
import { IBookingUser } from 'app/shared/model/booking-user.model';
import { getEntities as getBookingUsers } from 'app/entities/booking-user/booking-user.reducer';
import { IApplicationUser } from 'app/shared/model/application-user.model';
import { getEntities as getApplicationUsers } from 'app/entities/application-user/application-user.reducer';

export const ActivityUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diningDetails = useAppSelector(state => state.diningDetails.entities);
  const locations = useAppSelector(state => state.location.entities);
  const users = useAppSelector(state => state.userManagement.users);
  const activityEntity = useAppSelector(state => state.activity.entity);
  const loading = useAppSelector(state => state.activity.loading);
  const updating = useAppSelector(state => state.activity.updating);
  const updateSuccess = useAppSelector(state => state.activity.updateSuccess);
  const activityTypeValues = Object.keys(ActivityType);
  const keywords = useAppSelector(state => state.keyword.entities);
  const bookingUsers = useAppSelector(state => state.bookingUser.entities);
  const applicationUsers = useAppSelector(state => state.applicationUser.entities);

  const handleClose = () => {
    navigate('/activity' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
    dispatch(getDiningDetails({}));
    dispatch(getLocations({}));
    dispatch(getUsers({}));
    dispatch(getKeywords({}));
    dispatch(getBookingUsers({}));
    dispatch(getApplicationUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.startDate = convertDateTimeToServer(values.startDate);
    values.endDate = convertDateTimeToServer(values.endDate);
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.modifiedDate = convertDateTimeToServer(values.modifiedDate);

    const entity = {
      ...activityEntity,
      ...values,
      keywords: mapIdList(values.keywords),
      location: locations.find(it => it.id.toString() === values.location.toString()),
      diningDetails: diningDetails.find(it => it.id.toString() === values.diningDetails.toString()),
      //user: users.find(it => it.id.toString() === values.user.toString()),
      //bookingUsers: mapIdList(values.bookingUsers),
      //applicationUsers: mapIdList(values.applicationUsers),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          startDate: displayDefaultDateTime(),
          endDate: displayDefaultDateTime(),
          createdDate: displayDefaultDateTime(),
          modifiedDate: displayDefaultDateTime(),
        }
      : {
          activityType: 'ADVENTURE',
          ...activityEntity,
          startDate: convertDateTimeFromServer(activityEntity.startDate),
          endDate: convertDateTimeFromServer(activityEntity.endDate),
          diningDetails: activityEntity?.diningDetails?.id,
          location: activityEntity?.location?.id,
          //user: activityEntity?.user?.id,
          createdDate: convertDateTimeFromServer(activityEntity.createdDate),
          modifiedDate: convertDateTimeFromServer(activityEntity.modifiedDate),
          keywords: activityEntity?.keywords?.map(e => e.id.toString()),
          //bookingUsers: activityEntity?.bookingUsers?.map(e => e.id.toString()),
          //applicationUsers: activityEntity?.applicationUsers?.map(e => e.id.toString()),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.activity.home.createOrEditLabel" data-cy="ActivityCreateUpdateHeading">
            <Translate contentKey="activitiesApp.activity.home.createOrEditLabel">Create or edit a Activity</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="activity-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('activitiesApp.activity.name')} id="activity-name" name="name" data-cy="name" type="text" />
              <ValidatedField
                label={translate('activitiesApp.activity.summaryDescription')}
                id="activity-summaryDescription"
                name="summaryDescription"
                data-cy="summaryDescription"
                type="textarea"
                rows="5"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.detailedDescription')}
                id="activity-detailedDescription"
                name="detailedDescription"
                data-cy="detailedDescription"
                type="textarea"
                rows="5"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.experienceHeader')}
              id="activity-experienceHeader"
              name="experienceHeader"
              data-cy="experienceHeader"
              type="textarea"
              rows="5"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.experienceShort')}
              id="activity-experienceShort"
              name="experienceShort"
              data-cy="experienceShort"
              type="textarea"
              rows="5"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.quote')}
                id="activity-quote"
                name="quote"
                data-cy="quote"
                type="textarea"
                rows="5"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.durationNote')}
                id="activity-durationNote"
                name="durationNote"
                data-cy="durationNote"
                type="textarea"
                rows="5"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.startDate')}
                id="activity-startDate"
                name="startDate"
                data-cy="startDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.endDate')}
                id="activity-endDate"
                name="endDate"
                data-cy="endDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.childFriendly')}
                id="activity-childFriendly"
                name="childFriendly"
                data-cy="childFriendly"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.childFriendlyNote')}
                id="activity-childFriendlyNote"
                name="childFriendlyNote"
                data-cy="childFriendlyNote"
                type="textarea"
                rows="5"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.activityType')}
                id="activity-activityType"
                name="activityType"
                data-cy="activityType"
                type="select"
              >
                {activityTypeValues.map(activityType => (
                  <option value={activityType} key={activityType}>
                    {translate('activitiesApp.ActivityType.' + activityType)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('activitiesApp.activity.createdDate')}
                id="activity-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.modifiedDate')}
                id="activity-modifiedDate"
                name="modifiedDate"
                data-cy="modifiedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.active')}
                id="activity-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.userName')}
                id="activity-userName"
                name="userName"
                data-cy="userName"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.whatsIncluded')}
                id="activity-whatsIncluded"
                name="whatsIncluded"
                data-cy="whatsIncluded"
                type="textarea"
                rows="5"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.whatToBring')}
                id="activity-whatToBring"
                name="whatToBring"
                data-cy="whatToBring"
                type="textarea"
                rows="5"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.departs')}
                id="activity-departs"
                name="departs"
                data-cy="departs"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.restrictions')}
                id="activity-restrictions"
                name="restrictions"
                data-cy="restrictions"
                type="textarea"
                rows="5"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.freeCancellation')}
                id="activity-freeCancellation"
                name="freeCancellation"
                data-cy="freeCancellation"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('activitiesApp.activity.cancellationNote')}
                id="activity-cancellationNote"
                name="cancellationNote"
                data-cy="cancellationNote"
                type="text"
              />
              <ValidatedField
                id="activity-diningDetails"
                name="diningDetails"
                data-cy="diningDetails"
                label={translate('activitiesApp.activity.diningDetails')}
                type="select"
              >
                <option value="" key="0" />
                {diningDetails
                  ? diningDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
              label={translate('activitiesApp.activity.mediaLinks')}
                id="activity-mediaLinks"
                name="mediaLinks"
                data-cy="mediaLinks"
                type="textarea"
                rows="5"
                />
              <ValidatedField
                id="activity-location"
                name="location"
                data-cy="location"
                label={translate('activitiesApp.activity.location')}
                type="select"
              >
                <option value="" key="0" />
                {locations
                  ? locations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.cityName}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              {/* <ValidatedField id="activity-user" name="user" data-cy="user" label={translate('activitiesApp.activity.user')} type="select">
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.login}
                      </option>
                    ))
                  : null}
              </ValidatedField> */}
              <ValidatedField
                label={translate('activitiesApp.activity.keyword')}
                id="activity-keyword"
                data-cy="keyword"
                type="select"
                multiple
                name="keywords"
              >
                <option value="" key="0" />
                {keywords
                  ? keywords.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.keyword}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              {/*  Not required to the user, will be setting with backend code.
              <ValidatedField
                label={translate('activitiesApp.activity.applicationUser')}
                id="activity-applicationUser"
                data-cy="applicationUser"
                type="select"
                multiple
                name="applicationUsers"
              >
                <option value="" key="0" />
                {applicationUsers
                  ? applicationUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                label={translate('activitiesApp.activity.bookingUser')}
                id="activity-bookingUser"
                data-cy="bookingUser"
                type="select"
                multiple
                name="bookingUsers"
              >
                <option value="" key="0" />
                {bookingUsers
                  ? bookingUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField> */}
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/activity" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ActivityUpdate;
